import React from "react";
import { Star } from "lucide-react";
import PageHero from "../components/blocks/PageHero";
import Section from "../components/ui/Section";
import PremiumButton from "../components/ui/PremiumButton";
import mockData from "../mockData";
import useSEO from "../hooks/useSEO";

const Reviews = () => {
  useSEO('/reviews');
  return (
    <div className="min-h-screen bg-[#050706] text-[#F4F1E8] pt-16">
      <PageHero
        title="Guest reviews"
        subtitle="Stories from our guests"
        image="https://images.unsplash.com/photo-1535332371349-a5d229f49cb5?auto=format&fit=crop&w=2400&q=80"
        heightClass="h-[52vh]"
      />

      <Section className="py-16">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center backdrop-blur-md">
            <div className="text-4xl font-light text-white">5.0</div>
            <div className="mt-3 flex justify-center">
              {[1, 2, 3, 4, 5].map((s) => (
                <Star key={`avg-star-${s}`} size={18} className="text-[#C9A227] fill-[#C9A227]" />
              ))}
            </div>
            <div className="mt-2 text-sm text-white/70">Average rating</div>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center backdrop-blur-md">
            <div className="text-4xl font-light text-white">120+</div>
            <div className="mt-2 text-sm text-white/70">Happy guests</div>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center backdrop-blur-md">
            <div className="text-4xl font-light text-white">98%</div>
            <div className="mt-2 text-sm text-white/70">Would recommend</div>
          </div>
        </div>

        <div className="mt-14">
          <div className="text-3xl md:text-4xl font-light text-white text-center">
            What our guests say
          </div>
          <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
            {mockData.reviews.map((review) => (
              <div
                key={review.id}
                className="rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-md"
              >
                <div className="flex items-center justify-between">
                  <div className="flex">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={`review-star-${review.id}-${i}`} size={16} className="text-[#C9A227] fill-[#C9A227]" />
                    ))}
                  </div>
                  {review.verified ? (
                    <span className="rounded-full border border-white/10 bg-black/20 px-3 py-1 text-xs text-white/70">
                      Verified guest
                    </span>
                  ) : null}
                </div>
                <p className="mt-4 text-sm text-white/70 leading-relaxed">“{review.text}”</p>
                <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-4">
                  <div className="text-sm font-semibold text-white">{review.name}</div>
                  <div className="text-xs text-white/55">{review.date}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center gap-3 text-center">
          <div className="text-sm text-white/70">
            Want to see more? View our listing on Google Maps.
          </div>
          <a
            href="https://www.google.com/maps/search/glowLAWNS+Resorts+%26+Home-stays"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PremiumButton variant="secondary" icon={false}>
              View on Google Maps
            </PremiumButton>
          </a>
        </div>
      </Section>
    </div>
  );
};

export default Reviews;
